import {
  Component,
  HostListener,
  Input,
  OnChanges,
  OnInit,
  SimpleChanges,
  ViewChild,
} from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import {
  faBalanceScale,
  faBalanceScaleRight,
  faChevronDown,
  faChevronRight,
  faCircle,
  faCoins,
  faEllipsisV,
  faFileAlt,
  faFileInvoiceDollar,
  faFileTimes,
  faFlagCheckered,
  faInfoCircle,
  faSignIn,
  faSignInAlt,
  faSignOut,
  faSignOutAlt,
  faSyncAlt,
  faTimes,
} from '@fortawesome/pro-regular-svg-icons';
import { TranslateService } from '@ngx-translate/core';
import {
  ActivitiesService,
  DeviceDetectorService,
  Currency,
} from '@techrules/portallib';
import { CommonService } from '@tech-services/common.service';
import { SessionService } from '@tech-services/session.service';
import { ModalOrderComponent } from './modal-order/modal-order.component';
import { ModalPartialdepositComponent } from './modal-partialdeposit/modal-partialdeposit.component';
import { ModalPartialwithdrawalComponent } from './modal-partialwithdrawal/modal-partialwithdrawal.component';
import { timer, throwError } from 'rxjs';
import { ModalTabledetailComponent } from './modal-tabledetail/modal-tabledetail.component';
import { faClock } from '@fortawesome/pro-solid-svg-icons';
import { Utils } from '@tech-utils/utils';
import { CurrencyPipe } from '@techrules/pipelib';

@Component({
  selector: 'tech-activities',
  templateUrl: './activities.component.html',
  styleUrls: ['./activities.component.scss', './../profileportfolio/portfolio-data/portfolio-data-shared-styles.scss',],
})
export class ActivitiesComponent implements OnInit, OnChanges {
  faTimes = faTimes;
  faFlagCheckered = faFlagCheckered;
  faSignInAlt = faSignInAlt;
  faBalanceScale = faBalanceScale;
  faSignIn = faSignIn;
  faSignOut = faSignOut;
  faSyncAlt = faSyncAlt;
  faSignOutAlt = faSignOutAlt;
  faBalanceScaleRight = faBalanceScaleRight;
  faCoins = faCoins;
  faFileInvoiceDollar = faFileInvoiceDollar;
  faFileTimes = faFileTimes;
  faCircle = faCircle;
  faChevronDown = faChevronDown;
  faChevronRight = faChevronRight;
  faInfoCircle = faInfoCircle;
  faEllipsisV = faEllipsisV;
  faFileAlt = faFileAlt;
  faClock = faClock;

  public isMobile: boolean;
  public activityList: any[] = [];
  public colsTrades = [];
  public DateString: string;
  public DateString2: string;
  public amount: string;
  private timer3s = timer(3000);
  public isVisiblemessage: boolean = false;
  public isClass: boolean = false;

  @Input() portfoliocode: string;
  @Input() initialdate: string;
  @Input() enddate: string;
  panelOpenState = false;
  public dateFormat: string = this.sessionService.dateFormat
    .replace('DD', 'dd')
    .replace('YYYY', 'yyyy')
    .replace('MMM', 'MM');

  constructor(
    private deviceService: DeviceDetectorService,
    private activitiesService: ActivitiesService,
    public dialog: MatDialog,
    private translate: TranslateService,
    private sessionService: SessionService,
    private commonService: CommonService,
    private currencySymbol: CurrencyPipe
  ) {}

  ngOnInit() {
    this.isMobile = this.deviceService.isMobile();
    this.translate.get('activities').subscribe((text: string) => {
      this.initTableColums();
    });
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.portfoliocode && changes.portfoliocode.currentValue) {
      this.getActivities();
    }
  }

  @HostListener('window:resize') onresize() {
    this.isMobile = this.deviceService.isMobile();
    this.initTableColums();
  }

  public onExpandOpen(item) {
    this.getOrders(item);
  }
  /**
    Función para crear las columnas en las tablas
  */
  initTableColums() {
    if (this.isMobile) {
      this.colsTrades = [
        {
          dataField: 'groupedDate',
          groupIndex: 0,
          groupCellTemplate: 'groupCellTemplate',
          cssClass: 'fontweight400',
        },
        {
          dataField: 'ProductName',
          width: '50%',
          cssClass: 'td-250',
          cellTemplate: 'templateMobile',
          hidingPriority: 0,
        },
      ];
    } else {
      this.colsTrades = [
        {
          dataField: 'groupedDate',
          groupIndex: 0,
          groupCellTemplate: 'groupCellTemplate',
          cssClass: 'fontweight400',
        },
        {
          dataField: 'ProductName',
          caption: this.translate.instant('k000036'),
          width: '50%',
          cellTemplate: 'templateName',
          hidingPriority: 1,
        },
        {
          type: 'detailExpand',
        },
      ];
    }
  }
  /**
    Función para llamar al handler de actividades
  */
  getActivities() {
    this.activitiesService
      .getActivities(this.portfoliocode, this.initialdate, this.enddate)
      .subscribe(
        (data) => {
          this.activityList = data.Activities; //[...this.activityList, ...data];
          this.activityList.forEach((n) => {
            n.CreatedDate = n.CreatedDate.replace(/ /g, 'T');
            n.CreatedDateString2 = new Date(n.CreatedDate).toLocaleString(
              this.sessionService.language,
              {
                day: 'numeric',
                month: 'numeric',
                year: 'numeric',
              }
            );

            n.CreatedDateString1 = new Date(n.CreatedDate).toLocaleString(
              this.sessionService.language,
              {
                day: 'numeric',
                month: 'short',
              }
            );

            n.groupedDate = new Date(n.CreatedDate).toLocaleString(
              this.sessionService.language,
              {
                month: 'long',
                year: 'numeric',
              }
            );

            let amountExecuted = this.currencySymbol.transform(
              n.AmountExecuted,
              n.InflowCashoutCCY ? n.InflowCashoutCCY : n.Currency
            );
            let inflowCashoutValue = this.currencySymbol.transform(
              n.InflowCashoutValue,
              n.InflowCashoutCCY ? n.InflowCashoutCCY : n.Currency
            );

            if (n.Type.TypeCode == '22' || n.Type.TypeCode == '23') {
              n.messageValues = Utils.formatString(
                this.translate.instant('k002998'),
                [amountExecuted, inflowCashoutValue, amountExecuted]
              );
              this.isVisiblemessage = true;
            }

            if (n.Type.TypeCode == '9' || n.Type.TypeCode == '14') {
              n.messageValues = Utils.formatString(
                this.translate.instant('k002999'),
                [amountExecuted]
              );
              this.isVisiblemessage = true;
            }
          });
        },
        (err) => {
          if (err.status === 404) {
            this.activityList = [];
            return;
          }

          this.commonService.errorManager('apirest_getActivities', err);
          this.activityList = [];
          return throwError(err);
        }
      );
  }
  /**
    Función para llamar al handler de ordenes en cada actividad
  */
  getOrders(item) {
    this.activitiesService
      .getActivitiesOrder(this.portfoliocode, item.ActivityId)
      .subscribe(
        (data) => {
          item.Orders = data; //[...this.activityList, ...data];
          item.Orders.forEach((n) => {
            n.OrderDate = n.OrderDate.replace(/ /g, 'T');
            n.groupedDate = new Date(n.OrderDate).toLocaleString(
              this.sessionService.language,
              {
                weekday: 'long',
                day: 'numeric',
                month: 'long',
                year: 'numeric',
              }
            );
          });
          this.panelOpenState = true;
        },
        (err) => {
          this.commonService.errorManager('apirest_getActivitiesOrder', err);
          return throwError(err);
        }
      );
  }
  /**
    Función para colocar linea vertical dependiendo de la actividad
  */
  public getTypeClass(typecode) {
    let icon = '';
    switch (typecode) {
      case '15':
      case '23':
        icon = 'vertical-timeline-icon background1';
        break;
      case '12':
        icon = 'vertical-timeline-icon background2';
        break;
      case '8':
      case '22':
        icon = 'vertical-timeline-icon background3';
        break;
      case '9':
        icon = 'vertical-timeline-icon background4';
        break;
      case '19':
        icon = 'vertical-timeline-icon background5';
        break;
      case '14':
        icon = 'vertical-timeline-icon background6';
        break;
      case '20':
        icon = 'vertical-timeline-icon background7';
        break;
      case '21':
      case '17':
        icon = 'vertical-timeline-icon background8';
        break;
      case '16':
        icon = 'vertical-timeline-icon background9';
        break;
      case '13':
        icon = 'vertical-timeline-icon background10';
        break;
      case '4':
        icon = 'vertical-timeline-icon background11';
        break;
      case '17':
        icon = 'vertical-timeline-icon background11';
        break;
    }
    return icon;
  }

  public getIcon(item): [string, string] {
    let icon;
    switch (item.Status) {
      case 'PENDING':
      case 'RETRY':
        icon = ['fal', 'clock']; //fas fa-circle
        break;
      case 'COMPLETED':
      case 'PARTIAL_COMPLETED':
      case 'PARTIALLY_COMPLETED':
        icon = ['far', 'check'];
        break;
      case 'CANCELLED':
      case 'CANCELED':
        icon = ['far', 'ban'];
        break;
      case 'ORDERS_IN_EXECUTION':
        icon = ['far', 'sync-alt']; //  fa-regular fa-rotate
        break;
      case 'EXPIRED':
        icon = ['fal', 'calendar-xmark'];
        break;
      case 'REJECTED':
        icon = ['fal', 'circle-xmark'];
        break;
      default:
        icon = ['fas', 'circle'];
    }
    return icon;
  }

  /**
    Función para colocar icono dependiendo de la actividad
  */
  public getActivitiesIcon(activities, color) {
    let icon = [];
    switch (activities) {
      case '15':
      case '23':
        if (color == '') icon = ['fal', 'flag-checkered'];
        else icon = ['fal', 'flag-checkered'];
        break;
      case '12':
        if (color == '') icon = ['fal', 'balance-scale'];
        else icon = ['fal', 'balance-scale'];
        break;
      case '8':
      case '22':
        if (color == '') icon = ['fal', 'sign-in'];
        else icon = ['fal', 'sign-in'];
        break;
      case '9':
        if (color == '') icon = ['fal', 'sign-out'];
        else icon = ['fal', 'sign-out'];
        break;
      case '19':
        if (color == '') icon = ['fal', 'sync-alt'];
        else icon = ['fal', 'sync-alt'];
        break;
      case '14':
        if (color == '') icon = ['fal', 'sign-out'];
        else icon = ['fal', 'sign-out'];
        break;
      case '20':
        if (color == '') icon = ['fal', 'balance-scale-right'];
        else icon = ['fal', 'balance-scale-right'];
        break;
      case '21':
      case '17':
        if (color == '') icon = ['fal', 'coins'];
        else icon = ['fal', 'coins'];
        break;
      case '16':
        if (color == '') icon = ['fal', 'file-invoice-dollar'];
        else icon = ['fal', 'file-invoice-dollar'];
        break;
      case '13':
        if (color == '') icon = ['fal', 'file-times'];
        else icon = ['fal', 'file-times'];
        break;
      case '4':
        if (color == '') icon = ['fal', 'file-alt'];
        else icon = ['fal', 'file-alt'];
        break;
    }
    return icon;
  }

  /**
    Función para colocar la clase que acompaña al ícono dependiendo de la actividad
  */
  public getActivitiesClass(activities, color) {
    let icon = '';
    switch (activities) {
      case '15':
      case '23':
        if (color == '') icon = 'color1';
        else icon = 'novisible2';
        break;
      case '12':
        if (color == '') icon = 'color2';
        else icon = 'novisible2';
        break;
      case '8':
      case '22':
        if (color == '') icon = ' color3 rotate';
        else icon = 'novisible2 rotate';
        break;
      case '9':
        if (color == '') icon = ' color4 rotate1';
        else icon = ' novisible2 rotate1 ';
        break;
      case '19':
        if (color == '') icon = ' color5';
        else icon = 'novisible2';
        break;
      case '14':
        if (color == '') icon = ' color6 rotate1';
        else icon = ' novisible2 rotate1';
        break;
      case '20':
        if (color == '') icon = ' color7';
        else icon = ' novisible2';
        break;
      case '21':
      case '17':
        if (color == '') icon = ' color8';
        else icon = ' novisible2';
        break;
      case '16':
        if (color == '') icon = ' color9';
        else icon = ' novisible2';
        break;
      case '13':
        if (color == '') icon = ' color10';
        else icon = ' novisible2';
        break;
      case '4':
        if (color == '') icon = ' color11';
        else icon = ' novisible2';
        break;
    }
    return icon;
  }
  /**
    Función para dar color al icono de la actividad modo mobile
  */
  public getChannelClassMovil(activities) {
    let icon = '';
    switch (activities) {
      case '15':
      case '23':
        icon = 'color1';
        break;
      case '12':
        icon = 'color2';
        break;
      case '8':
      case '22':
        icon = 'color3';
        break;
      case '9':
        icon = 'color4';
        break;
      case '19':
        icon = 'color5';
        break;
      case '14':
        icon = 'color6';
        break;
      case '20':
        icon = 'color7';
        break;
      case '21':
      case '17':
        icon = 'color8';
        break;
      case '16':
        icon = 'color9';
        break;
      case '13':
        icon = 'color10';
        break;
      case '4':
        icon = 'color11';
        break;
    }
    return icon;
  }
  /**
    Función para agregar clase en el mat-expansion panel
  */
  getIndicatorClass(item) {
    var css = '';
    switch (item.Status) {
      case 'PENDING':
      case 'RETRY':
        //css = 'mat-expansion-indicator-disabled colorazul';//Saco popup dependiendo si es cash in o cash out
        css = 'far fa-external-link-alt pointer';
        break;
      case 'CANCELLED':
      case 'CANCELED':
      case 'EXPIRED':
      case 'REJECTED':
        css = '';
        break;
      case 'ORDERS_IN_EXECUTION':
        css = 'far fa-sync-alt pointer'; //fa-rotate;
        break;
      case 'IN_PROGRESS':
        css = 'mat-expansion-indicator-refresh colorazul center pointer'; //saco un icono distinto en azul y popup
        break;
      default:
        css = 'mat-expansion-indicator-disabled colorgray pointer'; //Por defecto es en gris
    }

    if (item.Type.TypeCode === '4') {
      //Nueva propuesta
      css = '';
    }
    return css;
  }
  /**
    Función para deshabilitar o no el mat-expansion
  */
  isDisabled(item) {
    var disable = true;
    switch (item.Status) {
      case 'COMPLETED':
      case 'PARTIAL_COMPLETED':
      case 'PARTIALLY_COMPLETED':
        disable = false;
        break;
      default:
        disable = true;
    }
    return disable;
  }
  /**
    Función para colocar un icono para el tooltip dependiendo del estado de la actividad
  */
  isIcono(item) {
    var icono = false;
    switch (item.Status) {
      case 'CANCELLED':
      case 'CANCELED':
      case 'EXPIRED':
      case 'REJECTED':
      case 'PARTIAL_COMPLETED':
      case 'PARTIALLY_COMPLETED':
        icono = true;
        break;
      default:
        icono = false;
    }
    return icono;
  }
  /**
    Función para abrir popups modo desktop dependiendo del estado de la actividad
  */
  popupSee(item) {
    if (item.Status == 'PENDING' || item.Status == 'RETRY') {
      if (item.Type.TypeCode == '9' || item.Type.TypeCode == '14') {
        //Cash Out
        const dialogRef = this.dialog.open(ModalPartialwithdrawalComponent, {
          width: '90%',
          height: 'auto',
          maxWidth: '440px',
          minWidth: '420px',
          panelClass: 'dialogfluid-intocenter3',
          data: {
            portfolioCode: this.portfoliocode,
            activityId: item.ActivityId,
          },
          disableClose: true,
        });
        dialogRef.afterClosed().subscribe((result) => {
          this.getActivities();
        });
      } else {
        if (this.isMobile) {
          const dialogRef = this.dialog.open(ModalPartialdepositComponent, {
            width: '100%',
            height: '80%',
            maxWidth: '440px',
            minWidth: '420px',
            panelClass: 'dialogfluid-intocenter2',
            data: {
              portfolioCode: this.portfoliocode,
              activityId: item.ActivityId,
              activityType: item.Type.TypeCode,
            },
            disableClose: true,
          });
          dialogRef.afterClosed().subscribe((result) => {
            this.getActivities();
          });
        } else {
          const dialogRef = this.dialog.open(ModalPartialdepositComponent, {
            width: '90%',
            maxWidth: '540px',
            minWidth: '500px',
            panelClass: 'dialogfluid-intocenter2',
            data: {
              portfolioCode: this.portfoliocode,
              activityId: item.ActivityId,
              activityType: item.Type.TypeCode,
            },
            disableClose: true,
          });
          dialogRef.afterClosed().subscribe((result) => {
            this.getActivities();
          });
        }
      }
    } else {
      if (
        item.Status == 'ORDERS_IN_EXECUTION' ||
        item.Status == 'IN_PROGRESS'
      ) {
        const dialogRef = this.dialog.open(ModalOrderComponent, {
          width: '90%',
          maxWidth: '460px',
          minWidth: '400px',
          panelClass: 'dialogfluid-intocenter2',
          data: {},
          disableClose: true,
        });
        dialogRef.afterClosed().subscribe((result) => {});
      }
    }
  }

  /**
    Función para abrir popup del detalle modo mobile
  */
  openDetail(item, item2) {
    const dialogRef = this.dialog.open(ModalTabledetailComponent, {
      width: '100%',
      maxWidth: '100%',
      height: '100%',
      panelClass: [
        'dialogfluid-intocenter',
        'tranimate__animated',
        'tranimate__slideInRight',
      ],
      data: {
        item: item,
        item2: item2,
      },
      disableClose: true,
    });
    dialogRef.afterClosed().subscribe((result) => {});
  }
  /**
    Función para abrir tooltip dependiendo del estado de la actividad
  */
  public activitiesTooltipShow(tooltip, item) {
    switch (item.Status) {
      case 'CANCELLED':
      case 'CANCELED':
        tooltip.message = 'Actividad cancelada'; //this.translate.instant('k000036');
        break;
      case 'REJECTED':
        tooltip.message = this.translate.instant('k003008');
        break;
      case 'EXPIRED':
        tooltip.message = this.translate.instant('k002576');
        break;
      case 'PARTIAL_COMPLETED':
      case 'PARTIALLY_COMPLETED':
        tooltip.message = this.translate.instant('k002577');
        break;
      case 'COMPLETED':
        tooltip.message = this.translate.instant('k002952'); //"La cantidad mostrada es la cantidad finalmente ejecutada y puede no ser la misma que la solicitada ya que existen ajustes según el producto o el mercado que pueden hacerla diferir. No obstante, la diferencia entre ambas se encuentra en tu cuenta de efectivo.";
        //this.translate.instant('k002576');
        break;
      default:
        tooltip.message = '';
    }
    tooltip.show();
    this.timer3s.subscribe(() => {
      tooltip.hide();
    });
  }

  /**
    Función para desaparecer la primera columna que viene por defecto en la tabla
  */
  onRowPrepared(e) {
    let commandExpand = e.rowElement.querySelector('.dx-command-expand');
    if (commandExpand) {
      let sibling = commandExpand.nextSibling;
      let colspan = Number.parseInt(sibling.getAttribute('colspan'));
      if (!colspan) colspan = 1;
      sibling.setAttribute('colspan', colspan + 1);
      commandExpand.remove();
    }
  }

  /**
    Función para colocar un border a la izquierda en modo Desktop
  */
  onRowExpanded(e) {
    const grid = e.component;
    const row = grid.getRowIndexByKey(e.key);
    const el = grid.getRowElement(row)[0];
    const detail = grid.getRowElement(row + 1)[0];
    el.classList.add('borderleft');
    detail.classList.add('borderleft');
    //anim.classList.add('opendetails_animation');

    grid.selectRows(e.key);
  }
  /**
    Función para colocar un sombreado sobre la fila de la tabla
  */
  onRowClick(e) {
    const key = e.component.getKeyByRowIndex(e.rowIndex);
    const expanded = e.component.isRowExpanded(key);
    if (expanded) {
      e.component.collapseRow(key);
    } else {
      e.component.expandRow(key);
    }
  }

  onCellPrepared(e) {
    if (e.rowType === 'data' && e.column.command === 'expand') {
      e.cellElement.classList.remove('dx-datagrid-expand');
    }
  }

  onRowCollapsed(e) {
    const grid = e.component;
    grid.selectRows(null);
  }
}
